import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { checkImgType } from '../../utilities/image_util';

import {
  closePhotoGallery,
  setCurrentGalleryIndex,
} from '../../actions/photoGallery';

const LightBoxGallery = () => {
  const { photoList, show, currentIndex } = useSelector(
    state => state.photoGallery,
  );

  const dispatch = useDispatch();

  if (show) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }
  if (!photoList || !photoList.length || !show) return null;

  const nextIndex = (currentIndex + 1) % photoList.length;
  const prevIndex = (currentIndex + photoList.length - 1) % photoList.length;

  const mainSrc = checkImgType({
    data: photoList[currentIndex],
    widthLimit: 1400,
  });
  const nextSrc = checkImgType({
    data: photoList[nextIndex],
    widthLimit: 1400,
  });
  const prevSrc = checkImgType({
    data: photoList[prevIndex],
    widthLimit: 1400,
  });
  const onMoveNextRequest = () => {
    dispatch(setCurrentGalleryIndex(nextIndex));
  };
  const onMovePrevRequest = () => {
    dispatch(setCurrentGalleryIndex(prevIndex));
  };
  const onCloseRequest = () => dispatch(closePhotoGallery());

  return (
    <Lightbox
      mainSrc={mainSrc}
      nextSrc={nextSrc}
      prevSrc={prevSrc}
      onCloseRequest={onCloseRequest}
      onMoveNextRequest={onMoveNextRequest}
      onMovePrevRequest={onMovePrevRequest}
    />
  );
};

export default LightBoxGallery;
